// eslint-disable-next-line
import { UserLayout } from '@/layouts'

/**
 * Note: 路由配置项
 *
 * hidden: true                     // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true                 // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式
 *                                  // 只有一个时，会将那个子路由当做根路由显示在侧边栏
 *                                  // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect             // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题,此名称与页面name一致
 * meta : {
    noCache: true                   // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'                  // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'                // 设置该路由的图标
  }
 */
export const indexRouterMap = [
  {
    path: '/index',
    name: 'Index',
    component: 'Index',
    meta: { title: '数据看板', noCache: false, hidden: true, icon: 'data', hiddenHeaderContent: true },
  },
  {
    path: '/account/center',
    name: 'Center',
    component: 'AccountCenter',
    meta: { title: '个人中心', noCache: true },
    hidden: true,
  },
  {
    path: '/account/settings',
    name: 'Settings',
    component: 'AccountSettings',
    meta: { title: '个人设置', noCache: true },
    hidden: true,
  },
  {
    path: '/monitor/job/log',
    name: 'JobLog',
    component: 'JobLog',
    meta: { title: '调度日志', noCache: true },
    permissions: ['monitor:job:list'],
    hidden: true,
  },
  {
    path: '/system/role/authUser',
    name: 'AuthUser',
    component: 'AuthUser',
    meta: { title: '分配用户', noCache: true },
    permissions: ['system:role:edit'],
    hidden: true,
  },
  {
    path: '/system/notice/form',
    name: 'NoticeForm',
    component: 'NoticeForm',
    meta: { title: '公告编辑', noCache: true },
    permissions: ['system:notice:edit', 'system:notice:add'],
    hidden: true,
  },
  {
    path: '/gen/edit',
    name: 'GenEdit',
    component: 'GenEdit',
    meta: { title: '修改生成配置', noCache: true },
    permissions: ['tool:gen:edit'],
    hidden: true,
  },
  {
    path: '/houses/detail/index',
    name: 'HousesDetails',
    component: 'HousesDetails',
    meta: { title: '房源详情', noCache: false },
    hidden: true,
  },
  {
    path: '/houses/detail/sell',
    name: 'HousesDetailsSell',
    component: 'HousesDetailsSell',
    meta: { title: '房源出售详情', noCache: false },
    hidden: true,
  },

  {
    path: '/houses/add',
    name: 'HousesAdd',
    component: 'HousesAdd',
    meta: { title: '房源出租新增', noCache: false },
    hidden: true,
  },
  {
    path: '/houses/sell/add',
    name: 'HousesSellAdd',
    component: 'HousesSellAdd',
    meta: { title: '房源出售新增', noCache: false },
    hidden: true,
  },
  {
    path: '/houses',
    name: 'Houses',
    component: 'Houses',
    meta: { title: '房源出租', noCache: true },
    hidden: true,
  },
  {
    path: '/houses/edit',
    name: 'HousesAdd',
    component: 'HousesAdd',
    meta: { title: '房源编辑', noCache: false },
    hidden: true,
  },
  {
    path: '/houses/edit',
    name: 'HousesAdd',
    component: 'HousesAdd',
    meta: { title: '房源编辑', noCache: false },
    hidden: true,
  },
  // {
  //   path:'/houses/edit',
  //   name:'HousesDetailsEdit',
  //   component:'HousesDetailsEdit',
  //   meta: { title: '房源编辑', noCache: true },
  //   hidden: true
  // },
  // {
  //   path: '/gen/details',
  //   name: 'GenDetails',
  //   component: 'GenDetails',
  //   meta: { title: '房源详情', noCache: true },
  //   hidden: true
  // }
  {
    path: '/tourist/add',
    name: 'TouristAdd',
    component: 'touristAdd',
    meta: { title: '客源新增', noCache: false, keepAlive: true },
    hidden: true,
  },
  {
    path: '/tourist/details',
    name: 'TouristDetails',
    component: 'touristDetails',
    meta: { title: '客源详情', noCache: false },
    hidden: true,
  },

  {
    path: '/tourist/sellAdd',
    name: 'TouristSellAdd',
    component: 'touristSellAdd',
    meta: { title: '售客/客源新增', noCache: false },
    hidden: true,
  },
  {
    path: '/tourist/sellDetails',
    name: 'touristSellDetails',
    component: 'touristSellDetails',
    meta: { title: '售客/客源详情', noCache: false },
    hidden: true,
  },

  // 新增合同
  {
    path: '/contract/new',
    name: 'ContractAdd',
    component: 'contractAdd',
    meta: { title: '合同', noCache: false },
    hidden: true,
  },
  // 合同详情
  {
    path: '/contract/details',
    name: 'contractDetails',
    component: 'contractDetails',
    meta: { title: '合同详情', noCache: true },
    hidden: true,
  },
  // 业绩榜单
  {
    path: '/achievement/performanceList',
    name: 'achievementPerformanceList',
    component: 'achievementPerformanceList',
    meta: { title: '业绩榜单', noCache: true },
    hidden: true,
  },
  {
    path: '/achievement/personRpt',
    name: 'achievementPersonRpt',
    component: 'achievementPersonRpt',
    meta: { title: '业绩报表-个人', noCache: true },
    hidden: true,
  },
  {
    path: '/achievement/groupRpt',
    name: 'achievementGroupRpt',
    component: 'achievementGroupRpt',
    meta: { title: '业绩报表-小组', noCache: true },
    hidden: true,
  },
  {
    path: '/achievement/achievementRpt',
    name: 'achievementRpt',
    component: 'achievementRpt',
    meta: { title: '业绩报表-门店', noCache: true },
    hidden: true,
  },
  {
    path: '/profession/add',
    name: 'professionSave',
    component: 'professionSave',
    meta: { title: '职级新增', noCache: true },
    hidden: true,
  },
  {
    path: '/profession/edit',
    name: 'professionSave',
    component: 'professionSave',
    meta: { title: '职级编辑', noCache: true },
    hidden: true,
  },
  {
    path: '/businessDistrict/add',
    name: 'businessDisSave',
    component: 'businessDisSave',
    meta: { title: '商圈新增', noCache: true },
    hidden: true,
  },
  {
    path: '/businessDistrict/edit',
    name: 'businessDisSave',
    component: 'businessDisSave',
    meta: { title: '商圈编辑', noCache: true },
    hidden: true,
  },
  {
    path: '/street/add',
    name: 'streetSave',
    component: 'streetSave',
    meta: { title: '街道新增', noCache: true },
    hidden: true,
  },
  {
    path: '/street/edit',
    name: 'streetSave',
    component: 'streetSave',
    meta: { title: '街道编辑', noCache: true },
    hidden: true,
  },
  {
    path: '/street/detail',
    name: 'streetDetail',
    component: 'streetDetail',
    meta: { title: '街道详情', noCache: true },
    hidden: true,
  },
  {
    path: '/community/add',
    name: 'communitySave',
    component: 'communitySave',
    meta: { title: '小区新增', noCache: true },
    hidden: true,
  },
  {
    path: '/community/edit',
    name: 'communitySave',
    component: 'communitySave',
    meta: { title: '小区编辑', noCache: true },
    hidden: true,
  },
  {
    path: '/learning/details',
    name: 'learningDetails',
    component: 'learningDetails',
    meta: { title: '学习管理详情', noCache: true },
    hidden: true,
  },
  // ,{
  //   path: '/house/houses/list/index',
  //   name: 'rentHouseList',
  //   component: 'rentHouseList',
  //   meta: { title: '租房列表', noCache: false },
  //   hidden: false
  // }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login'),
      },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Register'),
      },
    ],
  },

  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404'),
  },
]
